import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="w-full">
      {/* Terms Content */}
      <div className=" w-full ">
        <p className="text-start font-['Roboto'] text-black text-lg">
          The website{" "}
          <a
            href="https://www.iskconvijayawada.org"
            className="text-blue-500 no-underline"
          >
            www.iskconvijayawada.org
          </a>{" "}
          is fully owned by International Society of Krishna Consciousness
          (ISKCON), Hare Krishna Land, vijayawada, Skew Bridge, Krishna Lanka,
          Vijayawada - 520013
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Your use of the Site is governed by the policies, terms, and
          conditions set forth below. Please read the following information
          carefully. By using this Site or donating through the site, you
          indicate your acceptance of, and agreement to be bound by, the terms
          set forth below. If you do not agree to these terms and conditions,
          please do not use this Site.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          These terms and conditions may be changed by ISKCON in the future. It
          is your responsibility as a user to periodically return to this page
          to review the terms and conditions for amendments. The amended terms
          shall take effect automatically the day they are posted on the site.
          Your continued use of the web site following any amendments will
          constitute agreement to such amendments. These Terms of Service were
          last revised on May 30th, 2020.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Your continued usage of the site, shall be in acceptance to the terms
          that may be updated in future with retrospective effect. In case you
          do not agree to any terms your sole remedy is to stop using the
          website.
        </p>
      </div>

      {/* Privacy Policy */}
      <h2 className="text-2xl font-bold text-[#c61d21]">Privacy Policy</h2>
      <div>
        <p className="text-start font-['Roboto'] text-black text-lg">
          This privacy notice discloses the privacy practices for{" "}
          <a
            href="https://www.iskconvijayawada.org"
            className="text-blue-500 no-underline"
          >
            www.iskconvijayawada.org
          </a>
          . This privacy notice applies solely to information collected by this
          website. It will notify you of the following:
        </p>
        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            What personally identifiable information is collected from you
            through the website, how it is used and with whom it may be shared.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            What choices are available to you regarding the use of your data.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            The security procedures in place to protect the misuse of your
            information.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            How you can correct any inaccuracies in the information.
          </li>
        </ol>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          Your Access to and Control Over Information
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          You may opt out of any future contacts from us at any time. You can do
          the following at any time by contacting us via the email address or
          phone number given on our website:
        </p>

        <ol className="list-decimal font-['Roboto'] ">
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            See what data we have about you, if any.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Change/correct any data we have about you.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21] ">
            Have us delete any data we have about you.
          </li>
          <li className="text-lg [&::marker]:text-3xl [&::marker]:text-[#c61d21]">
            Express any concern you have about our use of your data.
          </li>
        </ol>
      </div>

      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          <h2 className="text-2xl font-bold text-[#c61d21]">Security</h2>
        </h2>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We take precautions to protect your information. When you submit
          sensitive information via the website, your information is protected
          both online and offline.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          We take precautions to protect your information. When you submit
          sensitive information via the website, your information is protected
          both online and offline.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          While we use encryption to protect sensitive information transmitted
          online, we also protect your information offline. Only employees who
          need the information to perform a specific job (for example, billing
          or customer service) are granted access to personally identifiable
          information. The computer servers in which we store personally
          identifiable information are kept in a highly secure environment.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          If you feel that we are not abiding by this privacy policy, you should
          contact our business head immediately via telephone at +91-8006880038
          or via email at seva@iskconvijaywada.org
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-[#c61d21]">
          <h2 className="text-2xl font-bold text-[#c61d21]">
            Refund and Cancellation Policy
          </h2>
        </h2>

        <p className="text-start font-['Roboto'] text-black text-lg">
          ISKCON currently accepts donations through its Online Payment Gateway
          Facility for various charitable / social purposes. ISKCON also accepts
          the payment of "booking of our Guest House". Any payment made multiple
          times due to error, or any other kind of erroneous payment may be
          brought to the notice of the Site officials and the payment would be
          refunded if the Site official is satisfied with the cause and/or
          reason of error by the payee.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          All donations and/or payment made through the Site, the acceptance of
          the same is at the sole discretion of the temple management and its
          trustees. The management reserves its sole rights to accept or cancel
          any donation and/or payment without assigning any reason thereof.
        </p>
        <p className="text-start font-['Roboto'] text-black text-lg">
          Please note that donations once made cannot be charged back, except in
          cases of fraudulent use, once investigation is carried out by
          necessary governmental / Bank authorities and proofs substantiated. In
          case any donation receipt is issued against the same, that shall stand
          cancelled, and any income tax benefit so derived shall be null and
          void.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
